import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import {
  setSelectedSort as setSelectedSortAction,
  setSortUpdated as setSortUpdatedAction,
} from 'services/actions/sortActions';

import { selectPageTrackingFullData } from 'selectors/trackingSelector';
import { track } from 'utils/segment';
import { sortIdToTrackingValue, getSortValues } from 'utils/sort';

import styles from './SelectSort.module.css';

function SelectSort(props) {
  const {
    selectedSort,
    setSelectedSortAction,
    viewSize,
    loggedIn,
    trackingData,
    setSortUpdatedAction,
  } = props;
  const options = getSortValues(loggedIn);

  function handleSortTracking(newSelectedSort) {
    const data = {
      ...trackingData,
      experience: 'Sort By',
      sort_name: sortIdToTrackingValue[newSelectedSort],
    };
    track('Products Sorted', data);
  }

  function handleSelectSort(e) {
    const newSelectedSort = e.target.value;
    setSortUpdatedAction(true);
    setSelectedSortAction(newSelectedSort);
    handleSortTracking(newSelectedSort);
  }

  if (selectedSort === null) return <></>;
  return (
    <div className={classNames(styles[viewSize], styles.selectContainer)}>
      <select
        value={selectedSort}
        onChange={handleSelectSort}
        data-testid="sort-selector-container"
        data-dd-action-name="Sort button"
      >
        {options.map((sort) => (
          <option value={sort.id} key={sort.id}>
            {sort.name}
          </option>
        ))}
      </select>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    selectedSort: state.sortState.selectedSort,
    viewSize: state.viewState.viewSize,
    loggedIn: state.userState.loggedIn,
    trackingData: selectPageTrackingFullData(state),
  };
}

const mapDispatchToProps = {
  setSelectedSortAction,
  setSortUpdatedAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSort);
